import {createDivIn, createImgIn, setElementInnerHTML} from '../../ui_utils/DomUtils.ts'
import {LobbyImage} from '@colonist/types'
import {type SocketDataTypes} from '../../../../../shared/SocketDataTypes.ts'
import {RoomSettingConstants} from '@colonist/game-base-types'
import {createTooltipIn} from '../../ui_utils/TooltipUtils.ts'

export class UILobbyTableRowNoTrollsController {
    private readonly noTrollsIcon: HTMLDivElement

    constructor(container: HTMLTableCellElement, roomData: SocketDataTypes.LobbyRowData) {
        this.noTrollsIcon = createDivIn(container, 'no_trolls_icon')
        this.update(roomData.minimumKarma)
    }

    update(minimumKarma: number, oldRoomData?: SocketDataTypes.LobbyRowData) {
        if(!UILobbyTableRowNoTrollsController.changedNoTrollsData(minimumKarma, oldRoomData)) return
        this.removeNoTrollsIcon()
        if(UILobbyTableRowNoTrollsController.isNoTrollsRoom(minimumKarma)) this.addNoTrollsIcon()
    }

    private removeNoTrollsIcon() {
        setElementInnerHTML(this.noTrollsIcon, {key: 'strings:colonistCommon.utils.emptyString'})
    }

    private addNoTrollsIcon() {
        const karmaImage = createImgIn(this.noTrollsIcon, LobbyImage.IconNoTroll)
        createTooltipIn(karmaImage, {key: 'strings:roomPage.options.noTrollsGame.title'})
    }

    private static changedNoTrollsData(minimumKarma: number, oldRoomData?: SocketDataTypes.LobbyRowData): boolean {
        if(oldRoomData == undefined) return true
        if(oldRoomData.minimumKarma != minimumKarma) return true
        return false
    }

    private static isNoTrollsRoom(minimumKarma: number): boolean {
        return minimumKarma == RoomSettingConstants.NO_TROLLS_KARMA_THRESHOLD
    }
}
